import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hidden", "trigger", "menu", "search", "count", "option", "empty", "label"]
  static values = {
    placeholder: { type: String, default: "사용자를 선택하세요" }
  }

  connect() {
    this.closeHandler = this.handleOutsideClick.bind(this)
    document.addEventListener("click", this.closeHandler)
    this.filter()
    this.syncSelection()
  }

  disconnect() {
    document.removeEventListener("click", this.closeHandler)
  }

  toggle() {
    if (this.menuTarget.style.display === "block") {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.menuTarget.style.display = "block"
    this.searchTarget.focus()
    this.searchTarget.select()
  }

  close() {
    this.menuTarget.style.display = "none"
  }

  filter() {
    const query = this.searchTarget.value.trim().toLowerCase()
    let visibleCount = 0

    this.optionTargets.forEach((option) => {
      const matches = option.dataset.searchText.includes(query)
      option.style.display = matches ? "flex" : "none"
      if (matches) visibleCount += 1
    })

    this.countTarget.textContent = query.length > 0 ? `${visibleCount}명 검색됨` : `전체 ${this.optionTargets.length}명`
    this.emptyTarget.style.display = visibleCount === 0 ? "block" : "none"
  }

  select(event) {
    const option = event.currentTarget
    this.hiddenTarget.value = option.dataset.value
    this.labelTarget.textContent = option.dataset.label
    this.syncSelection()
    this.close()
  }

  handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  syncSelection() {
    const selectedValue = this.hiddenTarget.value
    let selectedLabel = ""

    this.optionTargets.forEach((option) => {
      const isSelected = option.dataset.value === selectedValue
      option.style.background = isSelected ? "#EEF2FF" : "#FFFFFF"
      option.style.color = isSelected ? "#4338CA" : "#111827"
      if (isSelected) selectedLabel = option.dataset.label
      const check = option.querySelector("[data-select-filter-check]")
      if (check) check.style.visibility = isSelected ? "visible" : "hidden"
    })

    if (selectedValue && selectedLabel.length > 0) {
      this.labelTarget.textContent = selectedLabel
      this.labelTarget.style.color = "#111827"
    } else {
      this.labelTarget.textContent = this.placeholderValue
      this.labelTarget.style.color = "#9CA3AF"
    }
  }
}
